import { gql } from '@apollo/client'

export const GET_PRODUCTS_BY_CAMPAIGN = gql`
  query ($campaignId: String!, $countryCode: String) {
    getProductsByCampaignId(campaignId: $campaignId, countryCode: $countryCode) {
      alter_names {
        id
        artist_name
        product_name
        product_id
      }
      facts {
        chart
        position_current
        product_id
        id
        peak
        position_current_at
        position_last
      }
      radio_updates
      dsp_updates
      gps_status
      campaign_id
      configuration
      name
      active
      publish_date
      parent_id
      id
    }
  }
`
